// ShopStore.js
import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class ShopStore {
  shops = [];
  isLoading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchShops() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiHandler.get("/api/shops");
      runInAction(() => {
        this.shops = response;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error fetching shops:", error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async createShop(shopData) {
    try {
      const response = await apiHandler.post("/api/shops", shopData);
      await this.fetchShops(); // Refresh the shops list after creating
      return response;
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error creating shop:", error);
      throw error;
    }
  }

  async updateShop(shopId, shopData) {
    try {
      const response = await apiHandler.put(`/api/shops/${shopId}`, shopData);
      await this.fetchShops(); // Refresh the shops list after updating
      return response;
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error(`Error updating shop with ID ${shopId}:`, error);
      throw error;
    }
  }

  async deleteShop(shopId) {
    try {
      await apiHandler.delete(`/api/shops/${shopId}`);
      runInAction(() => {
        this.shops = this.shops.filter((shop) => shop.id !== shopId);
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error(`Error deleting shop with ID ${shopId}:`, error);
      throw error;
    }
  }

  clearError() {
    this.error = null;
  }
}

const shopStore = new ShopStore();
export default shopStore;
